import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Title, Meta } from '@angular/platform-browser';

import { Lightbox, LightboxConfig, LightboxEvent, LIGHTBOX_EVENT, IEvent, IAlbum } from 'angular2-lightbox';
import { AboutService } from './about.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.less'],
  encapsulation: ViewEncapsulation.None
})

export class AboutComponent implements OnInit, OnDestroy {

	public albums: Array<IAlbum>;
	private _options: Object;
	public data: object = {};
	public images: Object = {
		image: ''
	};
	private inscription: Subscription;
	private _defaultUrl = 'http://api.clinicacaesegatos.com/uploads/images';


	constructor(private _service: AboutService,
				private _lightbox: Lightbox,
				private _lightboxEvent: LightboxEvent,
				private _lighboxConfig: LightboxConfig,
				private _titleService: Title,
				private _meta: Meta) {
					this._titleService.setTitle( 'Sobre o Hospital Veterinário Stolf');
				}

	ngOnInit() {
		this._meta.addTag({
			name: 'title',
			content: 'Sobre o Hospital Veterinário Stolf - Lages SC'
		});
		this._meta.addTag({
			name: 'description',
			content: 'Atualmente, o Hospital Veterinário Stolf conta com uma equipe especializada e ampla estrutura física. Os diversos setores da empresa dispõem de equipamentos dotados de tecnologia de ponta, os quais auxiliam diretamente no diagnóstico preciso.'
		});
		this.getData();
		this.getImages();
	}

	getData() {
		this.inscription = this._service.getData()
        .subscribe(
            response => {
				this.data = response;
			},
            error => {
                console.error ( error );
            }
        );
	}

	getImages() {
		this.inscription = this._service.getImages()
        .subscribe(
            response => {
				this.images = response;
				this.albums = [];
				this._options = {};
				for (let i = 0; i <= Object.keys(this.images).length; i++) {
					if (typeof this.images[i] !== 'undefined') {
						const src = this._defaultUrl + '/' + this.images[i]['image'];
						const album = {
							src: src,
							caption: 'Hospital Veterinário Stolf',
							thumb: src
						}
						this.albums.push(album);
					}
				}
			},
            error => {
                console.error ( error );
            }
        );
	}

	openImage(index: number): void {
		this.inscription = this._lightboxEvent.lightboxEvent$
		.subscribe(
			(event: IEvent) => this._onReceivedEvent(event)
		);
		this._lightbox.open(this.albums, index, {
			wrapAround: true,
		});
	}

	private _onReceivedEvent(event: IEvent): void {
		if (event.id === LIGHTBOX_EVENT.CLOSE) {
			this.inscription.unsubscribe();
		}
	}

	ngOnDestroy() {
		this.inscription.unsubscribe();
	}
}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/about/about.component.ts